import Navbar from './Navbar';

const Header = ({ admin }) => {
  return (
    <header>
      <div className="nav-area">
        <a href="/" className="logo">
          Logo
        </a>
        <Navbar admin={admin} />
      </div>
    </header>
  );
};

export default Header;